import React from 'react'
import { ArrayField } from 'react-hook-form'
import ControlledMultiSelectGroupInput from 'transfix-form/components/ControlledMultiSelectGroupInput.tsx/ControlledMultiSelectGroupInput'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import { ShipmentsIcon } from 'transfix-icons/build'
import { Grid } from 'transfix-ui/core'
import { SELECTION_TYPE_OPTIONS, SHIPMENT_STATUS_OPTIONS } from '../constants'
import { useIssueRuleFormContext, getErrorMessage, TIssueRuleFormFormSchema } from './RuleForm'
import TriggerCard from './TriggerCard'

interface IShipmentStatusCardProps {
  onAddTrigger: () => void
  isAddTriggerDisabled: boolean
  onRemove: () => void
  showClearButton: boolean
  onCancel: () => void
  index: number
  node: Partial<ArrayField<TIssueRuleFormFormSchema['nodes'][number], 'key'>>
}

const ShipmentStatusCard = ({
  index,
  isAddTriggerDisabled,
  node,
  onAddTrigger,
  onCancel,
  onRemove,
  showClearButton,
}: IShipmentStatusCardProps) => {
  const { control, errors } = useIssueRuleFormContext()

  return (
    <TriggerCard
      icon={<ShipmentsIcon className='inline' size='xlarge' color='skyBlue6' />}
      isAddTriggerDisabled={isAddTriggerDisabled}
      onAddTrigger={onAddTrigger}
      onCancel={onCancel}
      onRemove={onRemove}
      showClearButton={showClearButton}
      title='Shipment Status'>
      <Grid container spacing={2}>
        <Grid item lg={12} xl={6}>
          <ControlledSelect
            control={control}
            name={`nodes[${index}].shipmentStatusOperator`}
            defaultValue={node.shipmentStatusOperator}
            SelectProps={{
              options: SELECTION_TYPE_OPTIONS,
              disabled: true,
            }}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <ControlledMultiSelectGroupInput
            name={`nodes[${index}].shipmentStatusFields`}
            control={control}
            defaultValue={node.shipmentStatusFields}
            options={SHIPMENT_STATUS_OPTIONS}
            InputMultiSelectProps={{
              placeholder: 'Select Statuses',
              clearable: true,
              invalid: !!getErrorMessage(errors, `nodes[${index}].shipmentStatusFields`),
              validationMessage: getErrorMessage(errors, `nodes[${index}].shipmentStatusFields`),
            }}
          />
        </Grid>
      </Grid>
    </TriggerCard>
  )
}

export default ShipmentStatusCard
